import script from "./AirSterileModalContent.vue?vue&type=script&setup=true&lang=js"
export * from "./AirSterileModalContent.vue?vue&type=script&setup=true&lang=js"

import "./AirSterileModalContent.vue?vue&type=style&index=0&id=244c1068&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-244c1068"]])

export default __exports__